import React from 'react';
import { Button } from '../../../components/ui/button';
import { Badge } from '../../../components/ui/badge';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from '../../../components/ui/dialog';
import { CLOSED_STAGES } from '../pipeline/constants';

export const PipelineMoveDialog = ({ handleMoveToStage, moveDialogOpen, pipelineInfo, pipelineStages, selectedDeal, setMoveDialogOpen, updating }) => (
      <Dialog open={moveDialogOpen} onOpenChange={setMoveDialogOpen}>
        <DialogContent className="max-w-[95vw] sm:max-w-md mx-2 sm:mx-auto">
          <DialogHeader>
            <DialogTitle className="text-base sm:text-lg">Move Deal to Stage</DialogTitle>
            <DialogDescription className="text-xs sm:text-sm truncate">
              Select a stage for "{selectedDeal?.Deal_Name}"
            </DialogDescription>
          </DialogHeader>
          
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-1.5 sm:gap-2 py-2 sm:py-4 max-h-[50vh] overflow-y-auto">
            {pipelineStages.map(stage => {
              const StageIcon = stage.icon;
              const isCurrentStage = selectedDeal?.Stage === stage.id;
              
              return (
                <Button
                  key={stage.id}
                  variant={isCurrentStage ? "default" : "outline"}
                  className={`justify-start h-auto py-2 sm:py-3 text-left ${isCurrentStage ? stage.color + ' text-white' : ''}`}
                  onClick={() => !isCurrentStage && handleMoveToStage(selectedDeal, stage.id)}
                  disabled={isCurrentStage || updating}
                >
                  <StageIcon className="w-3.5 h-3.5 sm:w-4 sm:h-4 mr-1.5 sm:mr-2 flex-shrink-0" />
                  <span className="text-xs sm:text-sm truncate">{stage.label}</span>
                  {isCurrentStage && <Badge className="ml-auto bg-white/20 text-xs flex-shrink-0">Current</Badge>}
                </Button>
              );
            })}
          </div>
          
          <div className="border-t pt-3 sm:pt-4">
            <p className="text-xs sm:text-sm text-gray-500 mb-2">Close Deal</p>
            <div className="flex gap-1.5 sm:gap-2">
              {CLOSED_STAGES.filter(cs => 
                pipelineInfo?.stages?.some(s => s.name === cs.id)
              ).map(stage => (
                <Button
                  key={stage.id}
                  variant="outline"
                  size="sm"
                  className={`flex-1 ${stage.textColor} border-current text-xs sm:text-sm`}
                  onClick={() => handleMoveToStage(selectedDeal, stage.id)}
                  disabled={updating}
                >
                  <stage.icon className="w-3.5 h-3.5 sm:w-4 sm:h-4 mr-1 sm:mr-2" />
                  <span className="hidden sm:inline">{stage.label}</span>
                  <span className="sm:hidden">{stage.label === 'Completed' ? '✓' : '✗'}</span>
                </Button>
              ))}
            </div>
          </div>
          
          <DialogFooter className="mt-2 sm:mt-0">
            <Button variant="ghost" size="sm" onClick={() => setMoveDialogOpen(false)}>
              Cancel
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
);
